export default function BartjaStokut() {
    return (
        <div style={{ padding: "50px" }}>
            <h1>Ne Zhvillim</h1>
        </div>
    )
}